import { render, staticRenderFns } from "./ClientMagicLogin.vue?vue&type=template&id=42422b36&scoped=true"
import script from "./ClientMagicLogin.vue?vue&type=script&lang=js"
export * from "./ClientMagicLogin.vue?vue&type=script&lang=js"
import style0 from "./ClientMagicLogin.vue?vue&type=style&index=0&id=42422b36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42422b36",
  null
  
)

export default component.exports